import axios, { AxiosResponse } from 'axios'
import { fetchJwt } from '.'
import { UploadFile, UsersPermissionsUser } from '../generated/graphql'

const BASE = process.env.REACT_APP_API_HOST || ''

export type StrapiLoginPayload = {
  jwt: string
  user: UsersPermissionsUser
}

const forgotPassword = async (email: string): Promise<AxiosResponse<any>> => {
  try {
    return await axios.post(BASE + '/auth/forgot-password', {
      email
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

const changePassword = async (
  code: UsersPermissionsUser,
  password: string,
  passwordConfirmation: string
) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + fetchJwt()
    }
  }
  const bodyparameters = {
    code,
    password,
    passwordConfirmation
  }

  try {
    return await axios.post(BASE + '/changepassword', bodyparameters, config)
  } catch (error) {
    return Promise.reject(error)
  }
}
const resetPassword = async (code: string, password: string, passwordConfirmation: string) => {
  try {
    return await axios.post(BASE + '/auth/reset-password', {
      code,
      password,
      passwordConfirmation
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

// const login = async (
//   email: string,
//   password: string
// ): Promise<AxiosResponse<StrapiLoginPayload>> => {
//   try {
//     // First authenticate to get JWT
//     const authResponse = await axios.post(BASE + '/api/auth/local', {
//       identifier: email,
//       password
//     })

//     const { jwt, user } = authResponse.data

//     // Then fetch complete user data with populated relations
//     const userResponse = await axios.get(
//       BASE + `/api/users/${user.id}?populate[language]=*&populate[company]=*&populate[role]=*&populate[programmes][populate][programme_types][populate][sub_modules][populate]=sections&populate[division]=*&populate[region]=*&populate[profilePicture]=*`,
//       {
//         headers: {
//           Authorization: `Bearer ${jwt}`
//         }
//       }
//     )
//     console.log({userResponse})

//     // Return JWT with fully populated user data
//     return {
//       ...authResponse,
//       data: {
//         jwt,
//         user: userResponse.data
//       }
//     }
//   } catch (error) {
//     return Promise.reject(error)
//   }
// }
const login = async (
  email: string,
  password: string
): Promise<AxiosResponse<StrapiLoginPayload>> => {
  try {
    // First authenticate to get JWT
    const authResponse = await axios.post(BASE + '/api/auth/local', {
      identifier: email,
      password
    })

    const { jwt, user } = authResponse.data

    // Fetch complete user data with all relations populated
    const userResponse = await axios.get(
      BASE +
        `/api/users/${user.id}?populate[language]=*&populate[company]=*&populate[role]=*&populate[division]=*&populate[region]=*&populate[profilePicture]=*&populate[programmes][populate][programme_types][populate][sub_modules][populate]=sections`,
      {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      }
    )

    // Return JWT with fully populated user data
    return {
      ...authResponse,
      data: {
        jwt,
        user: userResponse.data
      }
    }
  } catch (error) {
    return Promise.reject(error)
  }
}
const register = async (
  email: string,
  password: string
): Promise<AxiosResponse<StrapiLoginPayload>> => {
  try {
    return await axios.post(BASE + '/auth/local/register', {
      username: email.toLowerCase(),
      email,
      password
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

const upload = async (
  file: File,
  onUploadProgress?: (progressEvent: ProgressEvent, file: File) => void
): Promise<AxiosResponse<UploadFile[]>> => {
  const formData = new FormData()
  formData.append('files', file)

  const res = await fetch(BASE + '/api/upload', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${fetchJwt()}`
    },
    body: formData
  })

  if (!res.ok) {
    const err = await res.json()
    throw new Error(err?.error?.message || `Upload failed: ${res.status}`)
  }

  const data = await res.json()
  return {
    data,
    status: res.status,
    statusText: res.statusText,
    headers: {},
    config: {} as any
  } as AxiosResponse<UploadFile[]>
}

const socialAuth = async (
  provider: string,
  accessToken: string
): Promise<AxiosResponse<StrapiLoginPayload>> => {
  try {
    return await axios.get(BASE + '/auth/' + provider + '/callback' + accessToken)
  } catch (err) {
    return Promise.reject(err)
  }
}

export default {
  forgotPassword,
  changePassword,
  resetPassword,
  login,
  register,
  upload,
  socialAuth
}
